<form style="text-align: left; margin-bottom: 15px;" novalidate [formGroup]="globalData.ristoranteEditForm">
    <input formControlName="data" [class.error1]="!globalData.ristoranteEditForm.controls.data.valid && globalData.ristoranteEditForm.controls.data"
        autocomplete="off" class="form-control " (click)="datePickerIdEdit.toggle()" placeholder="gg-mm-aaaa"
        [(ngModel)]="globalData.dataEditRistorante" ngbDatepicker #datePickerIdEdit="ngbDatepicker">

    <div no-lines *ngIf="(globalData.ristoranteEditForm.get('data').hasError('required')) ">
        <div style="color: red !important" class="error" *ngIf="globalData.ristoranteEditForm.get('data').hasError('required') ">
            Selezionare il giorno della prenotazione
        </div>
    </div>
</form>